// extracted by mini-css-extract-plugin
export default {"cartContainer":"cartContainer__OTA1N","cartWrapper":"cartWrapper__NDNjY"};